/* eslint-disable react/prop-types */
import classes from "./composed-view-one.module.scss";
import Label from "@/components-library/widgets/label";
import Button from "@/components-library/widgets/button";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";

import classNames from "classnames";
function ComposedViewOne({
  header,
  title,
  subTitle,
  content,
  image,
  reverse,
  button,
  onClick,
  className,
}) {
  const Image = (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames({
        [classes.subContainerLeft]: !reverse,
        [classes.subContainerRight]: reverse,
      })}
    >
      <img
        src={image}
        alt="Logo"
        className={classNames(classes.image, {
          [classes.reverse]: reverse,
        })}
      />
    </Flex>
  );

  const Content = (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classNames({
        [classes.subContainerLeft]: !reverse,
        [classes.subContainerRight]: reverse,
        [classes.reverse]: reverse,
      })}
    >
      {header && (
        <Label
          weight="bold"
          tag="h5"
          color="primary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}

      <Label
        weight="bold"
        tag="h2"
        color="secondary"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>

      {subTitle && (
        <Label
          weight="bold"
          tag="h6"
          color="secondary"
          align="start"
          className={classes.subTitle}
        >
          {subTitle}
        </Label>
      )}
      <Label align="start" size="md" color="secondary">
        {content}
      </Label>
      {button && (
        <Button
          size="sm"
          color="primary"
          className={classes.button}
          onClick={onClick}
        >
          {button.title}
        </Button>
      )}
    </Flex>
  );

  if (reverse) {
    return (
      <Grid
        columns="1fr 1fr"
        className={classNames(classes.container, className)}
      >
        {Content}
        {Image}
      </Grid>
    );
  } else {
    return (
      <Grid
        columns="1fr 1fr"
        className={classNames(classes.container, className)}
      >
        {Image}
        {Content}
      </Grid>
    );
  }
}

export default ComposedViewOne;
